import { applyMiddleware, combineReducers, createStore } from "redux";
// import logger from "redux-logger";
import { listProfileImageReducer } from "./reducers/profileReducer";
// Reducers
// import userReducer from "./reducers/user";

// import { composeWithDevTools } from "redux-devtools-extension";
import { composeWithDevTools } from "@redux-devtools/extension";
import thunk from "redux-thunk";

const reducer = combineReducers({
  listProfileImage: listProfileImageReducer,
});

const middleware = [thunk];
const store = createStore(
  reducer,
  // initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);
// const store = createStore(combineReducers({ userReducer }));

export default store;

/**
 * 
<script>
  window.fbAsyncInit = function() {
    FB.init({
      appId      : '{your-app-id}',
      cookie     : true,
      xfbml      : true,
      version    : '{api-version}'
    });
      
    FB.AppEvents.logPageView();   
      
  };

  (function(d, s, id){
     var js, fjs = d.getElementsByTagName(s)[0];
     if (d.getElementById(id)) {return;}
     js = d.createElement(s); js.id = id;
     js.src = "https://connect.facebook.net/en_US/sdk.js";
     fjs.parentNode.insertBefore(js, fjs);
   }(document, 'script', 'facebook-jssdk'));
</script>
 */
